import { inject } from '@angular/core'

import { LoggerFactory } from 'common/log'
import { Time } from 'media/time'

import { BaseInterface } from './base'

export class DummyInterface extends BaseInterface {
  override logger = inject(LoggerFactory).create('DummyInterface')
  fs: any

  proxyMode = false

  async init () {
    if (!window['dummyPanelInterface'] && !navigator.userAgent.includes('Electron')) {
      return
    }
    try {
      window['nodeRequire']('electron') // debug mode
      this.logger.info('Activating (fake)')
      this.active = true
      this.fs = window['nodeRequire']('fs')
    } catch {
      // Nothing.
    }
  }

  getFS () {
    return this.fs
  }

  getApp () {
    return 'Dummy'
  }

  getPlatform () {
    return 'win' as const
  }

  hasRestart () {
    return false
  }

  restart () {
    this.logger.warn('restart()')
  }

  importAssets (paths) {
    this.logger.warn('importAssets()', paths)
  }

  async getActiveSequencePaths () {
    this.logger.warn('getActiveSequencePaths()')
    return []
  }

  async getProjectPaths () {
    this.logger.warn('getProjectPaths()')
    return []
  }

  attachProxies (paths) {
    this.logger.warn('importAssets()', paths)
  }

  async isProxyMode () {
    return this.proxyMode
  }

  setProxyMode (enabled) {
    this.proxyMode = enabled
  }

  open (item) {
    this.logger.warn('open()', item)
  }

  hasConfig () {
    return !!window['config']
  }

  getConfig (key) {
    return window['config']?.get(key)
  }

  setConfig (key, value) {
    return window['config'].set(key, value)
  }

  getLocalPath () {
    throw new Error('Method not implemented.')
  }

  async importPath () {
    throw new Error('Method not implemented.')
  }

  async importDirs () {
    throw new Error('Method not implemented.')
  }

  getSystemPath (): string {
    throw new Error('Method not implemented.')
  }

  async getActiveSequenceID () {
    return null
  }

  async getActiveSequenceTimestamp () {
    return Time.zero
  }

  async setActiveSequenceTimestamp () {
    throw new Error('Method not implemented.')
  }
}
